/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ci_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Text is split by Unicode code point, so an emoji like 😀 is shown as one character (U+1F600) with its full UTF-8 byte sequence, not as broken surrogate halves.`)
};

const es_ci_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El texto se divide por punto de código Unicode, por lo que un emoji como 😀 se muestra como un carácter (U+1F600) con su secuencia de bytes UTF-8 completa, no como mitades de sustituto rotas.`)
};

const de_ci_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Text wird nach Unicode-Codepunkt aufgeteilt, sodass ein Emoji wie 😀 als ein einzelnes Zeichen (U+1F600) mit seiner vollständigen UTF-8-Byte-Sequenz angezeigt wird, nicht als fehlerhafte Surrogat-Hälften.`)
};

const nl_ci_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tekst wordt opgesplitst per Unicode-codepunt, dus een emoji zoals 😀 wordt weergegeven als één karakter (U+1F600) met zijn volledige UTF-8-bytereeks, niet als verbroken surrogaathalves.`)
};

const fr_ci_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le texte est divisé par point de code Unicode, donc un emoji comme 😀 est affiché comme un caractère (U+1F600) avec sa séquence d'octets UTF-8 complète, et non comme des moitiés de substitution cassées.`)
};

const it_ci_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il testo viene diviso per punto di codice Unicode, quindi un emoji come 😀 viene visualizzato come un carattere (U+1F600) con la sua intera sequenza di byte UTF-8, non come metà di sostituzione rotte.`)
};

const pt_br2_ci_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O texto é dividido por ponto de código Unicode, então um emoji como 😀 é mostrado como um caractere (U+1F600) com sua sequência de bytes UTF-8 completa, não como meias-substituas quebradas.`)
};

const pt_ci_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O texto é dividido por ponto de código Unicode, portanto um emoji como 😀 é mostrado como um carácter (U+1F600) com sua sequência de bytes UTF-8 completa, não como metades substitutas quebradas.`)
};

const ja_ci_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`「テキストは Unicode コードポイントで分割されるため、😀 のような絵文字は、壊れたサロゲートペアではなく、完全な UTF-8 バイトシーケンス (U+1F600) を持つ 1 文字として表示されます。」`)
};

const zh_ci_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文本按 Unicode 码点拆分，因此像 😀 这样的表情符号会显示为一个字符（U+1F600），并附带其完整的 UTF-8 字节序列，而不会被拆分成破碎的代理对。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ci_faq1_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ci_faq1_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ci_faq1_a", locale)
	if (locale === "en") return en_ci_faq1_a(inputs)
	if (locale === "es") return es_ci_faq1_a(inputs)
	if (locale === "de") return de_ci_faq1_a(inputs)
	if (locale === "nl") return nl_ci_faq1_a(inputs)
	if (locale === "fr") return fr_ci_faq1_a(inputs)
	if (locale === "it") return it_ci_faq1_a(inputs)
	if (locale === "pt-BR") return pt_br2_ci_faq1_a(inputs)
	if (locale === "pt") return pt_ci_faq1_a(inputs)
	if (locale === "ja") return ja_ci_faq1_a(inputs)
	return zh_ci_faq1_a(inputs)
};